import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { boxShadow, colors, verticalGutter } from '../../../styles';

export const StyledIcon = styled(Icon)`
  &,
  i.icon.close& {
    position: absolute;
    right: 0;
    top: 50%;
    margin-right: 0;
    cursor: pointer;

    /* mocking close icon style to svg icon */
    > .isvg {
      /* align with close button size */
      width: 2.75rem;
      height: 2.75rem;
      border: 0.25rem solid transparent;
      border-radius: 50%;
      transition: box-shadow 0.3s ease;
      margin: -1rem;
      transform: translate(-0.25rem, -2px);
    }

    &:hover {
      > .isvg {
        box-shadow: inset 0 0 3rem ${colors.greenBackground};
      }
    }
  }
`;

export default styled.div`
  position: absolute;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;

  &,
  .DayPicker,
  .DayPicker-Month {
    width: 100%;
  }

  /* react-day-picker override */
  .DayPicker {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 4px;
      left: 0;
      top: 0;
      box-shadow: ${boxShadow.medium};
      z-index: -1;
    }

    &-Caption,
    &-Weekday {
      position: relative;
      font-weight: bold;
      overflow: hidden;
      > * {
        position: relative;
        z-index: 2;
      }
    }

    &-Caption {
      margin-bottom: ${verticalGutter / 2}rem !important;
      /* expecting Grid inside */
      padding: 0.5rem 1.25rem;
      background: ${colors.lighterGrey};
      text-align: center;
      .select {
        width: 100%;
        /* for month dropdown */
        > select.ui.selection.dropdown {
          text-transform: capitalize;
        }
      }
      .ui.grid > .column {
        padding-left: 0.25rem;
        padding-right: 0.25rem;
      }
    }

    &-Weekday {
      text-transform: uppercase;
      color: ${colors.textColor};
    }

    &-Month {
      margin: 0;
    }

    &-Day {
      position: relative;
      background: transparent !important;
      > * {
        position: relative;
        z-index: 1;
      }
      &:focus {
        outline: none;
      }
      &:before {
        content: '';
        position: absolute;
        left: 50%;
        display: block;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background: transparent;
        transition: background 0.3s ease;
        transform: translateX(-50%);
        z-index: -1;
      }
      &:after {
        content: '';
        width: 0;
        height: 2.5rem;
        display: inline-block;
        vertical-align: middle;
      }

      &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        &:before {
          background: ${colors.primary};
        }
      }

      &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(.DayPicker-Day--selected):hover {
        &:before {
          background: ${colors.greenBackground};
        }
      }

      &--today {
        color: ${colors.primary};
      }

      &--disabled {
        color: inherit;
        opacity: 0.3;
      }
    }

    &-NavButton {
      z-index: 9;
      top: 0.95rem;

      &--next {
        right: 25%;
      }
      &--prev {
        right: auto;
        left: 25%;
      }
    }
  }

  /* namespace'd styles */
  &.datepicker {
    &--active {
      opacity: 1;
      z-index: 9;
    }
  }
`;
